<div class="modal-header">
  <h4 class="modal-title pull-left">Report Delay</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <ng-container *ngIf="!isDelayed">
    <p>
      You are about to set Report as <strong>Delayed</strong>.<br/>
      <strong>NOTICE:</strong> All notifications are snoozed while Report in Delay mode.
    </p>
    <p>
      Are you sure you want to set this Report as <strong>Delayed</strong>?
    </p>
  </ng-container>

  <ng-container *ngIf="isDelayed">
    <p>
      You are about to clear Report as <strong>No Longer Delayed</strong>.<br/>
      <strong>NOTICE:</strong> All notifications are will be enabled.
    </p>
    <p>
      Are you sure you want to set this Report as <strong>No Longer Delayed</strong>?
    </p>
  </ng-container>

  <!-- Delay Type -->
  <div class="row" *ngIf="!isDelayed">
    <div class="col-sm-12">
      <label class="rbv-label">Delay Type</label>
      <div class="check-group">
        <div class="checkbox-item mr-5">
          <input class="checkbox-custom" type='radio' [(ngModel)]="delay" [name]="'delay_type'" [id]="'delay_client'"
            [value]="DelayType.CLIENT" [checked]="delay === DelayType.CLIENT" />
          <label class="checkbox-custom-label" [for]="'delay_client'">Client Delay</label>
        </div>

        <div class="checkbox-item">
          <input class="checkbox-custom" type='radio' [(ngModel)]="delay" [name]="'delay_type'" [id]="'delay_reliant'"
            [value]="DelayType.RELIANT" [checked]="delay === DelayType.RELIANT" />
          <label class="checkbox-custom-label" [for]="'delay_reliant'">Reliant Delay</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Delay Notes -->
  <div class="row">
    <div class="col-sm-12">
      <label class="rbv-label">
        Delay Notes for Client Link
        <small>  (visible to client)</small>
      </label>
      <div class="area-wrapper">
        <textarea class="form-control rounded-0" rows="3" name="NOTES" [(ngModel)]="notes"></textarea>

        <div class="canned-actions" *ngIf="cannedResponses.length > 0">
          <div class="c-action" [style.color]="cr.FOREGROUND_COLOR" [style.background]="cr.BACKGROUND_COLOR" (click)="appendCannedAction(cr.CONTENT)" *ngFor="let cr of cannedResponses; let x = index">{{cr.NAME}}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Delay Reason -->
  <div class="row">
    <div class="col-sm-12">
      <label class="rbv-label">
        Reason
        <small>  (not visible to client)</small>
        <small>  (optional)</small>
      </label>
      <div class="area-wrapper">
        <textarea class="form-control rounded-0" rows="3" name="REASON" [(ngModel)]="reason"></textarea>

        <div class="canned-actions" *ngIf="cannedResponses.length > 0">
          <div class="c-action" [style.color]="cr.FOREGROUND_COLOR" [style.background]="cr.BACKGROUND_COLOR"
            (click)="appendCannedActionReason(cr.CONTENT)" *ngFor="let cr of cannedResponses; let x = index">{{cr.NAME}}
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="footer-wrapper" style="justify-content: flex-end;">
    <div class="actions">
      <button class="btn btn-rbv default" [disabled]="submitting" (click)="onCancel()">Cancel</button>
      <button class="btn btn-rbv warning" [disabled]="!isInputValid() || submitting" (click)="onConfirm()">Confirm</button>
    </div>
  </div>
</div>
